import {POST_QUERY} from "utils";

declare var $:any;

import * as React from 'react';
import {MainStageData} from "data/MainStageData";
import {observer} from "mobx-react";
import './MainStageStatusMessage.pcss';
import {UIState} from "data/UIState";
import {NavAvatar} from "components/nav/NavAvatar";

interface IMainStageStatusMessage_Props {

}

@observer
export class MainStageStatusMessage extends React.Component<IMainStageStatusMessage_Props> {

  render() {
    if(MainStageData.statusMessage) {
      return (
        <div className={`mainstage-status ${MainStageData.statusLevel}`}>
          <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>
          <div className="host">
              <NavAvatar user={UIState.healthFairHost} variant={'large'} />
              <div style={{ }}>
                <div className={"name"}>{UIState.healthFairHost.firstName} {UIState.healthFairHost.lastName}, Fair MC</div>
                {MainStageData.statusTimestamp && <div className={"timestamp"}>{MainStageData.statusTimestamp.fromNow()}</div> }
              </div>
          </div>
          <p className={'message'}>{MainStageData.statusMessage}</p>
        </div>
      );
    } else {
      return null;
    }

  }
}
